import React from 'react';
import PropTypes from 'prop-types';
import { BarChart } from 'react-easy-chart';

import styles from './scaleStyles.module.scss';

export const Scale = props => {
  return (
    <div className={styles.plotWrapper}>
      <BarChart
        axisLabels={{ x: 'Date', y: 'Communications' }}
        axes
        grid
        width={700}
        height={400}
        colorBars
        xType={'time'}
        data={props.data}
        barWidth={50}
        margin={{ top: 50, right: 100, bottom: 60, left: 70 }}
      />
    </div>
  );
};

Scale.propTypes = {
  noData: PropTypes.bool,
  data: PropTypes.array,
  entityData: PropTypes.object,
};
